import { atomWithReset } from 'jotai/utils';

import { AnnouncementModal } from './types';

export const announcementModalState = atomWithReset<AnnouncementModal>({
  isOpen: false,
  announcementId: null,
});
